import { Vue, Prop, Component } from "vue-property-decorator";
import CIOD from './CIOD.model';

@Component
export default class ScheduleActualCIOD extends Vue {

    @Prop() departmentId!: number;
    @Prop() departmentCode!: string;
    @Prop() departmentName!: string;    
    @Prop() start!: Date;
    @Prop() end!: Date;
    @Prop() shiftCode!: string;
    @Prop() clockInOuts!: CIOD[];
} 
